import './Header.css';
import logo from "../../assets/logo_lfu.png";
import {Link} from "react-router-dom";

function Header() {
    return (
        <header className="header-container">
            <div className="header-content">
                <div id="rlp-logo">
                    <Link to="/" aria-label="Startseite">
                        <img src={logo} alt="Logo des Landesamts für Umwelt Rheinland-Pfalz" className="logo"/>
                    </Link>
                </div>
                <h1 className="visually-hidden">Bodeninformationssystem Rheinland-Pfalz</h1>
                <Link to="/" className="header-name" aria-hidden="true" tabIndex={-1}>
                    Bodeninformationssystem Rheinland-Pfalz
                </Link>
            </div>
        </header>
    );
}

export default Header;
